import {createFileRoute} from '@tanstack/react-router';

import {parseNonEmpty, parsePage} from '@/lib/search-params';
import {SitesListPage} from '@/modules/sites/pages/SitesListPage';
import {ACTIVITY_ORDER, type Activity} from '@/lib/activity';
import {SITE_REGION_ORDER, type SiteRegion} from '@/lib/site-display';

/** URL state for the sites index. All fields optional. */
export interface SitesListSearch {
  activity?: Activity;
  region?: NonNullable<SiteRegion>;
  project?: string;
  q?: string;
  page?: number;
}

function parseActivity(value: unknown): Activity | undefined {
  return ACTIVITY_ORDER.find((a) => a === value);
}

function parseRegion(value: unknown): NonNullable<SiteRegion> | undefined {
  return SITE_REGION_ORDER.find((r) => r === value);
}

const validateSitesListSearch = (search: Record<string, unknown>): SitesListSearch => ({
  activity: parseActivity(search.activity),
  region: parseRegion(search.region),
  project: parseNonEmpty(search.project),
  q: parseNonEmpty(search.q),
  page: parsePage(search.page),
});

export const Route = createFileRoute('/_authenticated/sites/')({
  validateSearch: validateSitesListSearch,
  component: SitesListPage,
});
